import { Menu, UnstyledButton } from '@mantine/core';

import React, { useState } from 'react';
import { BasicMerchant } from '../../../type/admin.types';

import { ChevronDown, CircleCheck, CircleX } from 'tabler-icons-react';
import { AcquirerTypes } from '../../../enums/acquirer-types.enum';
import ApproveEntityModal from '../../modals/approve-entity-modal.component';
import DeclineMerchant from './decline-merchant.component';

interface Props {
  entity: BasicMerchant;
  status: string;
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
  acquirerColumn?: AcquirerTypes;
}

const StatusDropdown = ({
  entity,
  status,
  setRefreshTable,
  acquirerColumn,
}: Props) => {
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isDeclinedModalOpen, setIsDeclinedModalOpen] = useState(false);

  const capitalized = () => {
    return status.charAt(0) + status.slice(1).toLowerCase();
  };

  return (
    <>
      <DeclineMerchant
        entity={entity}
        handleClose={() => setIsDeclinedModalOpen(false)}
        isDeclinedModalOpen={isDeclinedModalOpen}
        updateTable={setRefreshTable}
        acquirerColumn={acquirerColumn}
      />
      <ApproveEntityModal
        entity={entity}
        isApproveModalOpen={isApproveModalOpen}
        setIsApproveModalOpen={setIsApproveModalOpen}
        updateTable={setRefreshTable}
        acquirerColumn={acquirerColumn}
      />
      {status === 'DISABLED' ? (
        <UnstyledButton
          className='status disabled'
          style={{
            marginTop: '2px',
            marginBottom: '2px',
            paddingTop: '5px',
            paddingBottom: '5px',
          }}
          disabled
        >
          Disabled
        </UnstyledButton>
      ) : (
        <Menu
          control={
            <UnstyledButton
              className={`status ${status.toLowerCase()}`}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              data-cy={'dropdown' + entity}
            >
              <div></div>
              <div>{capitalized()} </div>
              <ChevronDown size={16} strokeWidth={3} color={'white'} />
            </UnstyledButton>
          }
        >
          {status !== 'APPROVED' && (
            <Menu.Item onClick={() => setIsApproveModalOpen(true)}>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '.25rem' }}
              >
                <CircleCheck size={18} strokeWidth={2} color={'#1DC340'} />
                Approve
              </div>
            </Menu.Item>
          )}
          {status !== 'DECLINED' && (
            <Menu.Item
              onClick={() => {
                setIsDeclinedModalOpen(true);
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '.25rem' }}
              >
                <CircleX size={18} strokeWidth={2} color={'#FF0000'} />
                Decline
              </div>
            </Menu.Item>
          )}
        </Menu>
      )}
    </>
  );
};

export default StatusDropdown;
